import { gql } from 'graphql-request';

export const getFlightDetailsQuery = async (): Promise<string> => {
  const response = await fetch('/schemas/flightDetails.txt');
  const text = await response.text();

  const query = gql`
    ${text}
  `;

  return query;
};
